import Scroller from "./lib/scroller";

export default class Teaserslider extends Scroller {
    constructor(element) {
        super(element);
        this.controlLeft = document.querySelector('.control--left');
        this.controlRight = document.querySelector('.control--right');

        window.addEventListener('resize', () => this.moveControls());
        this.moveControls();

        this.element.addEventListener('wheel', (event) => this.recordWheelEvent(event));
    }

    /**
     * For the purpose of finding out usage patterns in regards to the highlight
     * teaser, we record wheel events i.e. a user is trying to scroll horizontally
     * We send these events to Analytics in hope to gain insights on user behaviour.
     * @param event
     */
    recordWheelEvent(event) {
        if(event.deltaX === 0) {
            return;
        }

        // Cancel if Analytics is not available
        if(typeof window.ga === 'undefined') {
            return;
        }

        window.ga('send', {
            hitType: 'event',
            eventCategory: 'Interaction',
            eventAction: 'scrollX',
            eventLabel: 'Highlight Teaser'
        });
    }

    moveControls() {
        if (this.controlRight === null || this.controlLeft === null) return;
        this.controlLeft.style.left = -this.element.getBoundingClientRect().x + 'px';
        this.controlRight.style.right = -this.element.getBoundingClientRect().x + 'px';
    }

    /**
     * If the size of items is equal or less to their container,
     * we don't need to slide anything so hide controls.
     */
    checkControlVisibility() {
        let dimensions = this.list.getBoundingClientRect();
        let scrollWidth = this.list.scrollWidth;

        if (dimensions.width >= scrollWidth) {
            return this.element.classList.add('teaser--no-control');
        }

        this.element.classList.remove('teaser--no-control')
    }

}
